(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hm-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    document.querySelectorAll('[data-hm-scroll-story]').forEach(story => {
      if (story.dataset.initialized) return;
      story.dataset.initialized = 'true';
      const hero = story.querySelector('.hm-hero');
      const logo = story.querySelector('.hm-zoom-logo');
      const content = story.querySelector('.hm-hero-content');
      const quote = story.querySelector('.hm-quote');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let frame = 0;
      const clamp = n => Math.max(0, Math.min(1, n));
      const paint = () => {
        frame = 0;
        if (motion.matches || story.getBoundingClientRect().top >= 0) {
          logo.style.transform = '';
          logo.style.opacity = '';
          content.style.opacity = '';
          content.inert = false;
          quote.style.opacity = '';
          quote.style.visibility = '';
          quote.style.pointerEvents = '';
          quote.inert = !motion.matches;
          logo.style.visibility = '';
          return;
        }
        const progress = clamp(-story.getBoundingClientRect().top / Math.max(1, story.offsetHeight - hero.offsetHeight));
        const zoom = clamp(progress / .68);
        const reveal = clamp((progress - .55) / .18);
        const stage = logo.parentElement.getBoundingClientRect();
        const centerX = stage.left + stage.width * .433;
        const centerY = stage.top + stage.height * .39;
        const heroBounds = hero.getBoundingClientRect();
        const scale = Math.pow(80, zoom);
        logo.style.transform = 'translate(' + ((heroBounds.left + hero.clientWidth / 2 - centerX) * zoom) + 'px,' + ((heroBounds.top + hero.clientHeight / 2 - centerY) * zoom) + 'px) scale(' + scale + ')';
        logo.style.opacity = String(1 - clamp((progress - .7) / .08));
        logo.style.visibility = progress >= .78 ? 'hidden' : 'visible';
        content.style.opacity = String(1 - clamp(progress / .2));
        content.inert = progress > .2;
        quote.style.opacity = String(reveal);
        quote.style.visibility = reveal > 0 ? 'visible' : 'hidden';
        quote.style.pointerEvents = reveal > .9 ? 'auto' : 'none';
        quote.inert = reveal < .9;
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(paint); };
      window.addEventListener('scroll', schedule, {passive:true});
      window.addEventListener('resize', schedule, {passive:true});
      window.addEventListener('pageshow', schedule);
      logo.addEventListener('load', schedule);
      motion.addEventListener('change', schedule);
      paint();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
